export default __webpack_public_path__ + "static/media/tek-login-image.7c689434.png";